import {
  Box,
  Button,
  ButtonGroup,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from '@chakra-ui/react';
import { useState } from 'react';
import { HabityTooltip } from '../tooltips';

type RemovePopoverProps = {
  triggerButton: TODO;
  title: string;
  tooltip?: string;
  onConfirm: () => void;
  loading?: boolean;
};

export const RemoveItemPopover = ({
  triggerButton,
  title,
  tooltip,
  onConfirm,
  loading = false,
}: RemovePopoverProps) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  return (
    <Popover onOpen={() => setTooltipOpen(false)}>
      {({ onClose, isOpen }) => (
        <HabityTooltip
          isOpen={!!tooltip && tooltipOpen && !isOpen}
          onOpen={() => setTooltipOpen(true)}
          onClose={() => setTooltipOpen(false)}
          label={tooltip}
        >
          <Box display="inline-block">
            <PopoverTrigger>{triggerButton}</PopoverTrigger>
            <PopoverContent>
              <PopoverArrow />
              <PopoverHeader fontSize="sm">{title}</PopoverHeader>
              <PopoverBody>
                <ButtonGroup>
                  <Button
                    size="sm"
                    onClick={onConfirm}
                    colorScheme="red"
                    isLoading={loading}
                  >
                    Bekräfta
                  </Button>
                  <Button
                    size="sm"
                    onClick={onClose}
                    disabled={loading}
                  >
                    Avbryt
                  </Button>
                </ButtonGroup>
              </PopoverBody>
            </PopoverContent>
          </Box>
        </HabityTooltip>
      )}
    </Popover>
  );
};
